/* eslint-disable @typescript-eslint/no-invalid-void-type */
import { apiSlice } from './apiSlice';
import Vehicle from '../../core/models/Vehicle';

export const inspectionApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    registerVehicleForInspection: builder.mutation<Vehicle, string>({
      query: (vehicleId) => ({
        url: '/vehicles/inspection',
        method: 'POST',
        body: { vehicleId: vehicleId },
      }),
      invalidatesTags: ['Vehicle'],
    }),
    getInspectionReport: builder.query<Vehicle, string>({
      query: (vehicleId) => ({
        url: `/vehicles/inspection/${vehicleId}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useRegisterVehicleForInspectionMutation, useGetInspectionReportQuery } =
  inspectionApiSlice;
